import React from 'react'

/**
 * What a sidebar row needs to act as a button: a role and a tab stop so it is
 * announced and reachable, and Enter or Space to activate it, as a button
 * would.
 */
/** Just below a sidebar button, for a menu it opens. */
export const belowButton = (button: HTMLElement): { top: number; left: number } => {
  const rect = button.getBoundingClientRect()
  return { top: rect.bottom + 4, left: rect.left }
}

export const rowButtonProps = (
  onActivate: (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void
) => ({
  role: 'button' as const,
  tabIndex: 0,
  onClick: (event: React.MouseEvent<HTMLElement>) => onActivate(event),
  onKeyDown: (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      // Space would otherwise scroll the sidebar.
      event.preventDefault()
      // The event goes through so a row that places a menu against itself
      // (currentTarget) works the same from the keyboard.
      onActivate(event)
    }
  }
})
